import { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../../../apps/frontend/src/context/ThemeStore';
import LoadingState from './LoadingState';
import QuestionAttempt from './QuestionAttempt';

const AttemptSimilarQsModal = ({ loading, data, onClose, packId, testId, checkSimilarQuestionsButton }) => {
  const { isDarkTheme } = useContext(ThemeContext);
  const [attemptedQuestions, setAttemptedQuestions] = useState([]);
  const [cachedData, setCachedData] = useState(null);

  // Cache the data when it's available
  useEffect(() => {
    if (data && !loading) {
      setCachedData(data);
    }
  }, [data, loading]);

  const handleQuestionAttempted = (questionId) => {
    setAttemptedQuestions((prev) => {
      if (prev.includes(questionId)) return prev;
      return [...prev, questionId];
    });
  };

  const handleAllQuestionsAttempted = () => {
    // This function can be used for any post-completion logic
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center backdrop-blur-md bg-[rgba(16,24,40,0.70)]"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md md:max-w-3xl md:h-auto p-4 flex justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Show loading only if we have no cached data AND still loading */}
        {loading && !cachedData ? (
          <LoadingState />
        ) : (
          // Show questions if we have data (either fresh or cached)
          (data || cachedData) && (
            <QuestionAttempt
              data={data || cachedData}
              onClose={onClose}
              packId={packId}
              testId={testId}
              onQuestionAttempted={handleQuestionAttempted}
              onAllQuestionsAttempted={handleAllQuestionsAttempted}
              attemptedQuestions={attemptedQuestions}
              checkSimilarQuestionsButton={checkSimilarQuestionsButton}
            />
          )
        )}
      </div>
    </div>
  );
};

export default AttemptSimilarQsModal;
